var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.disabled_pass && !_vm.disabled ? _c('div', {
    staticClass: "w-max-content w-max cursor-pointer flex hover:font-medium items-center",
    on: {
      "click": function ($event) {
        return _vm.del();
      }
    }
  }, [_c('span', {
    staticClass: "minus-button 2xl:h-10 2xl:w-10 2xl:mt-2"
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _vm.libelle != '' ? _c('span', {
    staticClass: "text-base text-gray-600 ml-3 flex-initial"
  }, [_vm._v("\n    " + _vm._s(_vm.libelle) + "\n  ")]) : _vm._e()]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }